import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { TemplateDocumentService } from "../../../../auth/service/template-document.service";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IDocumentTemplate } from "app/auth/models/document-id";
import { IDatatableConfig } from "app/auth/models/datatable";

@Component({
  selector: "app-template-list",
  templateUrl: "./template-list.component.html",
  styleUrls: ["./template-list.component.scss"],
})
export class TemplateListComponent implements OnInit {
  public config: IDatatableConfig;

  public tableLimit: number = 10;

  public searchKeyword: string = "";

  public contentHeader: IContentHeader;

  public templateList: IDocumentTemplate[];

  public filteredTemplate: IDocumentTemplate[] = [];

  constructor(
    public _templateDocumentService: TemplateDocumentService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _router: Router,
  ) {}

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_documents_template_list")) {
      await this._router.navigateByUrl("dashboard/main");
      return false;
    }
    this.contentHeader = {
      headerTitle: italian.data.MENU.DOCUMENT_TEMPLATE_LIST,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.DOCUMENT_TEMPLATE_LIST,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      searchable: true,
      exportable: true,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 70,
      footerHeight: 60,
      scrollbarH: true,
      columns: [
        {
          value: "title",
          text: italian.data.FIRSTNAME,
          width: 250,
          sortable: true,
        },
        {
          value: "category_name",
          text: italian.data.CATEGORY,
          width: 150,
          sortable: true,
        },
        {
          value: "require_signature",
          text: italian.data.SIGNATURE,
          width: 125,
          sortable: true,
        },
        {
          value: "require_acception",
          text: italian.data.INSERT.VIEW_DOCUMENT,
          width: 125,
          sortable: true,
        },
        {
          value: "in_onboarding",
          text: italian.data.ONBOARDING,
          width: 100,
          sortable: true,
        },
        {
          value: "update_date",
          text: italian.data.UPDATE_DATE,
          width: 130,
          sortable: true,
        },
      ],
    };

    await this.loadTemplateDocuments();
  }

  async loadTemplateDocuments() {
    await this._templateDocumentService.getList().then((response: IDocumentTemplate[]) => {
      this.templateList = response;
      this.templateDocumentList();
    });
    if (this.templateList && this.templateList.length > 0) {
      this.templateList.map(async (template) => {
        template.in_onboarding = template.in_onboarding === 1 ? await this._utilService.translate("YES") : await this._utilService.translate("NO");
        template.require_signature = template.require_signature === 1 ? await this._utilService.translate("REQUIRED_FEMALE") : await this._utilService.translate("NOT_REQUIRED_FEMALE");
        template.require_acception = template.require_acception === 1 ? await this._utilService.translate("REQUIRED_FEMALE") : await this._utilService.translate("NOT_REQUIRED_FEMALE");
        if (template.update_date) {
          template.update_date = this._utilService.formatDate(template.update_date, "DD/MM/YYYY");
        }
      });
    }
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  templateDocumentList() {
    let items: IDocumentTemplate[] = this.templateList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.templateList.filter(
        (item: IDocumentTemplate) => item.title.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()) || item.category_name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()),
      );
    }

    this.filteredTemplate = items;
  }

  async deleteTemplateDocument(currentTemplate) {
    if (!this._authenticationService.hasCapability("delete_document_template")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentTemplate.title;
    await this._utilService
      .showSWALDeleteConfirmation({
        title: "CONFIRM_DELETE_TITLE",
        text: deleteText,
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        this._utilService.showLoading();
        if (result.value) {
          await this._templateDocumentService
            .delete(currentTemplate.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadTemplateDocuments();
              });
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showSWALError({ text: "ERROR_DELETE_TEMPLATE_DOCUMENT" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }
}
